import WizardStep from "./WizardStep";

export default class ProcessBigQueryState extends WizardStep {
  type = WizardStep.TYPE_PROCESS;

  name = 'Process BigQuery';
  title = 'Process Big Query';
  subtitle = 'Aggregates imported revenue data using Big Query';
  estimate = 5;

  getHelpText() {
    return [
      'Click proceed.',
      'Prepare a cup of coffee.',
    ];
  }
}